import { render, staticRenderFns } from "./PointQuery.vue?vue&type=template&id=7c362a18&"
import script from "./PointQuery.vue?vue&type=script&lang=js&"
export * from "./PointQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports